import {useState} from 'react'

function useFormState(defaultValue) {
    const [data, setData] = useState(defaultValue)

    const handleChange = (event) => {
        setData(event.target.value)
    }

    return [data, handleChange, setData]
}

export default useFormState